// Auth
export const REGISTER_BY_EMAIL_ERROR: number                            = 1000;
export const LOGIN_BY_EMAIL_ERROR: number                               = 1001;
export const RECOVERY_PASSWORD_ERROR: number                            = 1002;
export const ACTIVATE_NEW_PASSWORD_ERROR: number                        = 1003;
export const SEND_RECOVERY_PASSWORD_CODE_ERROR: number                  = 1004;
export const SEND_VERIFICATION_CODE_ERROR: number                       = 1005;
export const APPLE_ID_AUTH_INIT_ERROR: number                           = 1006;
export const APPLE_ID_AUTH_SIGN_IN_ERROR: number                        = 1007;
export const LOGIN_BY_APPLE_ID_ERROR: number                            = 1008;
export const LOGIN_BY_GOOGLE_ERROR: number                              = 1009;
export const LOGIN_BY_VK_ID_ERROR: number                               = 1010;
export const AUTH_EXIT: number                                          = 1011;
export const CHECK_AUTH_ERROR: number                                   = 1012;
export const LOGIN_BY_YANDEX_ID_ERROR: number                           = 1013;
export const LOGIN_BY_TELEGRAM_ERROR: number                            = 1014;
export const LOGIN_SUCCESS_REDIRECT_ERROR: number                       = 1015;
export const LOGIN_BY_FACEBOOK_ERROR: number                            = 1016;
export const LOGIN_BY_FACEBOOK_SIGN_IN_ERROR: number                    = 1017;

// Profile
export const GET_PROFILE_INFO_ERROR: number                             = 2000;
export const SET_PROFILE_INFO_ERROR: number                             = 2001;

// Main
export const GET_INITIAL_CONFIG_ERROR: number                           = 3000;
export const UNAUTHORIZED: number                                       = 3001;

// Payments
export const PAYMENT_EXIT: number                                       = 4000;
export const PAYMENTS_PROCESS_ERROR: number                             = 4001;
export const PAYMENTS_YOOKASSA_INITIALIZING_WIDGET_ERROR: number        = 4002;
export const PAYMENTS_YOOKASSA_CLOSE_WIDGET_ERROR: number               = 4003;
export const PAYMENTS_YOOKASSA_SET_PENDING_PRIVATE_ERROR: number        = 4004;
export const PAYMENTS_YOOKASSA_FAIL_ERROR: number                       = 4005;
export const PAYMENTS_YOOKASSA_CREATE_ERROR: number                     = 4006;
export const PAYMENTS_STRIPE_CREATE_ERROR: number                       = 4007;
export const PAYMENTS_STRIPE_SET_PENDING_PRIVATE_ERROR: number          = 4008;
export const PAYMENTS_STRIPE_CLOSE_WIDGET_ERROR: number                 = 4009;
export const UPDATE_MAIL_TO_RECEIVE_CHECK_ERROR: number                 = 4010;
export const PAYMENTS_GET_GAME_DATA_ERROR: number                       = 4011;
export const PAYMENTS_YANDEX_PAY_CREATE_ERROR: number                   = 4012;
export const PAYMENTS_YANDEX_PAY_ABORT_PAYMENT_ERROR: number            = 4013;
export const PAYMENTS_YANDEX_PAY_REDIRECT_ERROR: number                 = 4014;
export const PAYMENTS_YANDEX_PAY_ERROR_PAYMENT: number                  = 4015;
export const PAYMENTS_YANDEX_PAY_ERROR_PAYMENT_API: number              = 4016;
export const PAYMENTS_GET_USER_PAYMENT_DATA_ERROR: number               = 4017;
export const PAYMENTS_STATE_REVOCABLE_ERROR: number                     = 4018;